export default "__VITE_ASSET__bf463892__"